import { useTexture } from '@react-three/drei';
import * as THREE from 'three';
import { FrontSide } from 'three';
import hdri from '../../../assets/the-galleries-panorama.jpeg';

const MallPanorama = () => {

  const mallTexture = useTexture(hdri);

  if (mallTexture.uuid) {
    return (
      <group>
        <mesh
          position={[0, -2, 0]}
					rotation={[0, 0, Math.PI]}
        >
          <sphereGeometry args={[-9, 64, 64]} />
          <meshPhongMaterial side={FrontSide} needsUpdate={true}>
            <primitive
              attach="map"
              object={mallTexture}
              anisotropy={4}
              format={THREE.RGBAFormat}
              colorSpace={THREE.SRGBColorSpace}
              mapping={THREE.EquirectangularReflectionMapping}
            />
          </meshPhongMaterial>
        </mesh>
        <mesh
          position={[0, -11.9, 0]}
          rotation={[-Math.PI / 2, 0, 0]}
					receiveShadow
        >
          <meshBasicMaterial color={0x000000} side={THREE.DoubleSide} />
          <planeGeometry args={[30, 30]} />
        </mesh>
      </group>
    );
  } else {
    return null;
  }
}

export default MallPanorama;